// a little function to help us with reordering the result
export const Reorder = (list, startIndex, endIndex) => {
   const result = Array.from(list);
   const [removed] = result.splice(startIndex, 1);
   result.splice(endIndex, 0, removed);

   return result;
};

const grid = 6;
export const getItemStyle = (isDragging, draggableStyle) => {
   return {
      // some basic styles to make the items look a bit nicer
      // userSelect: "none",
      // padding: grid * 2,
      // margin: `0 0 ${grid}px 0`,

      // change background colour if dragging
      opacity: isDragging ? "0.5" : "1",

      // styles we need to apply on draggables
      ...draggableStyle,
   };
};

export const getQuestionListStyle = (isDraggingOver) => ({
   background: isDraggingOver ? "lightblue" : "lightgrey",
});

export const getAnswerListStyle = (isDraggingOver, count) => ({
   opacity: isDraggingOver ? "0.5" : "1",
   gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
});

export function updateViewOptionsDecorator(item, fieldsView: string) {
   const decorators = item.decorators || [];
   const index = decorators.findIndex((d) => d.name === "ViewOptionsDecorator");

   if (index !== -1) {
      const oldDec = decorators[index];

      const newDec = {
         ...oldDec,
         properties: {
            ...(oldDec.properties || {}),
            fieldsView,
         },
      };

      const newDecorators = [...decorators];
      newDecorators[index] = newDec;

      return { ...item, decorators: newDecorators };
   }

   return {
      ...item,
      decorators: [
         ...decorators,
         {
            name: "ViewOptionsDecorator",
            properties: { fieldsView },
         },
      ],
   };
}

export const highlight = (txt) => {
   return txt.replace(/\{([^}]+)\}/g, `<span class="token">$1</span>`);
};
